import React, {useCallback, useEffect, useState} from "react";
import {BoardSearchResult, ReportsDetail} from "../../assets/GlobalStyles";
import ReportTable from "../../components/table/ReportTable";
import HorizontalScrollGuide from "../../components/table/HorizontalScrollGuide";
import PerformanceComparisonChart from "../../components/reports/PerformanceComparisonChart";
import {reportsInventory, reportsStaticsInventoryColumn, reportsUserStaticsInventoryColumn} from "./entity/inventory";
import {useAtomValue, useSetAtom} from "jotai";
import {modalController} from "../../store";
import {selectAdminStaticsInventory, selectUserStaticsInventory} from "../../services/reports/inventoryAxios";
import {ReportsCondition} from "../../components/reports/Condition";
import {sort} from "../../components/reports/sortList";
import {UserInfo} from "../layout";
import {ReportsInventoryModalComponent} from "../../components/reports/ModalComponents";
import {lockedRows, summaryReducer} from "./entity/common";
import {tokenResultAtom} from "../login/entity";
import {
  CollapseIcon, ConditionBody, ConditionSummary, ExcelHeaderButton, HeaderRight,
  ReportCard, ReportPage, SectionAccent, SectionHeader, SectionHeading, SummaryChip, TableBody
} from "./ReportSharedLayout";

export function ReportsInventoryModal(props){
  const setModal = useSetAtom(modalController)
  const handleClick = () => {
    if(!props.inventoryId) return
    setModal({isShow:true,width:1320,blur:true,modalComponent:() =>
      <ReportsInventoryModalComponent userId={props.userId} inventoryId={props.inventoryId} inventoryName={props.inventoryName}/>})
  }
  return <ReportsDetail onClick={e => {e.stopPropagation();handleClick()}}/>
}

export default function ReportsInventory(){
  const userInfoState = useAtomValue(UserInfo)
  const [searchCondition, setSearchCondition] = useState(reportsInventory)
  const [searchState, setSearchState] = useState(reportsInventory)
  const [totalCount, setTotalCount] = useState(0)
  const tokenInfoState = useAtomValue(tokenResultAtom)
  const [creativeInfo, setCreativeInfo] = useState({})
  const [isConditionOpen, setIsConditionOpen] = useState(false)
  const [downloadTrigger, setDownloadTrigger] = useState(0)
  const [chartData, setChartData] = useState([])

  const handleSearchCondition = useCallback(async ({skip,limit,sortInfo}) => {
    const condition = {...searchCondition,pageSize:30,currentPage:skip/limit===0?1:skip/limit+1,sortType:sort("INVENTORY_NAME_DESC",sortInfo)}
    const response = tokenInfoState.role !== "NORMAL"
        ? await selectAdminStaticsInventory(creativeInfo.id,condition)
        : await selectUserStaticsInventory(tokenInfoState.id,condition)
    if(!response) return {data:[],count:0}
    setTotalCount(response.totalElements)
    return {data:response.content,count:response.totalElements}
  },[searchCondition,creativeInfo.id,tokenInfoState.id,tokenInfoState.role])

  useEffect(() => {
    const condition = {...searchCondition,pageSize:100,currentPage:1,sortType:"REVENUE_AMOUNT_DESC"}
    const request = tokenInfoState.role !== "NORMAL"
        ? selectAdminStaticsInventory(creativeInfo.id,condition)
        : selectUserStaticsInventory(tokenInfoState.id,condition)
    request.then(response => setChartData(response?.content || []))
  },[searchCondition,creativeInfo.id,tokenInfoState.id,tokenInfoState.role])

  const onSearch = ({mediaInfo} = {}) => {
    setCreativeInfo(mediaInfo || {})
    setSearchCondition({...searchState})
  }
  const toggleCondition = () => setIsConditionOpen(open => !open)

  return (
    <ReportPage>
      <ReportCard $condition>
        <SectionHeader $clickable $open={isConditionOpen} role="button" tabIndex={0}
          aria-expanded={isConditionOpen} onClick={toggleCondition}
          onKeyDown={e => {if(e.key==="Enter"||e.key===" "){e.preventDefault();toggleCondition()}}}>
          <SectionHeading><SectionAccent/><div><strong>조회 조건</strong><span>매체, 광고 상품, 디바이스와 기간을 기준으로 지면별 데이터를 조회합니다.</span></div></SectionHeading>
          <HeaderRight>
            {!isConditionOpen && <ConditionSummary>
              <SummaryChip>매체 <b>{creativeInfo.siteName || "전체"}</b></SummaryChip>
              <SummaryChip>상품 <b>{searchCondition.productType || "전체"}</b></SummaryChip>
              <SummaryChip>디바이스 <b>{searchCondition.deviceType || "전체"}</b></SummaryChip>
              <SummaryChip>기간 <b>{searchCondition.searchStartDate} ~ {searchCondition.searchEndDate}</b></SummaryChip>
            </ConditionSummary>}
            <CollapseIcon $open={isConditionOpen}/>
          </HeaderRight>
        </SectionHeader>
        {isConditionOpen && <ConditionBody onClick={e => e.stopPropagation()}>
          <ReportsCondition modern searchMediaInfo={creativeInfo} searchState={searchState}
            setSearchState={setSearchState} onSearch={onSearch}/>
        </ConditionBody>}
      </ReportCard>

      <ReportCard>
        <PerformanceComparisonChart data={chartData} nameKey="inventoryName"
          title="지면별 주요 성과"
          description="수익금 기준 상위 5개 지면의 노출수와 수익금을 비교합니다."/>
      </ReportCard>

      <ReportCard>
        <SectionHeader>
          <SectionHeading><SectionAccent/><div><strong>지면별 데이터</strong><span>조회 조건에 해당하는 지면별 요청, 노출, 수익금과 ECPM을 확인합니다.</span></div></SectionHeading>
          <ExcelHeaderButton type="button" onClick={() => setDownloadTrigger(v => v + 1)}>엑셀 저장</ExcelHeaderButton>
        </SectionHeader>
        <TableBody>
          <HorizontalScrollGuide/>
          <BoardSearchResult>
            <ReportTable columns={userInfoState.email !== '' ? reportsUserStaticsInventoryColumn : reportsStaticsInventoryColumn}
              lockedRows={lockedRows} summaryReducer={summaryReducer} totalCount={[totalCount,'보고서']}
              defaultSortInfo={{name:"inventoryName",dir:-1}} data={handleSearchCondition}
              pagination livePagination downloadList={false} downloadTrigger={downloadTrigger}
              fileName="지면별_보고서" scrollThreshold={0.7} headerHeight={44} style={{minHeight:500}}/>
          </BoardSearchResult>
        </TableBody>
      </ReportCard>
    </ReportPage>
  )
}
